define('designers',['jquery', 'core'], function ($, core) {
    var module = {},
        browserSupportsHistoryStateFunctions = !!(window.history && window.history.replaceState);

    module.onDesignersFilterAction = function(context) {
        function submitGallery() {
            var originalForm = $('.js-designers-form');
            var form = originalForm;

            if (form.length) {
                if (browserSupportsHistoryStateFunctions) {
                    form = form.clone();
                }

                var formCategoryId = form.find('.js-designers-category-id');
                if (formCategoryId.val() == formCategoryId.data('default-value')) {
                    formCategoryId.remove();
                }

                if (browserSupportsHistoryStateFunctions) {
                    core.dom.doAction(form, function () {
                        $('html').removeClass('active-filter');

                        var query = form.serialize();
                        var url = form.attr('action') + (query.length ? '?' + query : '');
                        window.history.replaceState(undefined, '', url);

                        if (!core.ui.isElementInViewport($('.js-designers-scroll-to'), true)) {
                            core.ui.scrollTo('.js-designers-scroll-to');
                        }
                    });
                } else {
                    core.ui.lock('screen');
                    form.submit();
                }
            }
        }

        context.andFind('.js-designer-category-filter-clear-filter').click(function (e) {
            e.preventDefault();

            var formCategoryId = $('.js-designers-category-id');
            formCategoryId.val(formCategoryId.data('default-value'));

            submitGallery();
        });

        context.andFind('.js-designer-category-filter').click(function (e) {
            e.preventDefault();

            var $this = $(this);
            if (!$this.hasClass('active')) {
                var categoryId = $this.data('category-id');

                var formCategoryId = $('.js-designers-category-id');
                formCategoryId.val(categoryId);

                submitGallery();
            }
        });
    };


    module.onDesignerLetterClick = function(context) {
        context.andFind('.js-designer-letter-navigate').click(function(e) {
            e.preventDefault();
            var $this = $(this);
            var letterId = $this.data('id');

            core.ui.scrollTo($('.js-designerletter-id-' + letterId + ':visible'));
        });
    };

    // Initialize
    $(document).ready(function () {
        core.scopes.addHandler('*', function (context) {
            module.onDesignersFilterAction(context);
            module.onDesignerLetterClick(context);
        });
    });

    return module;
});
